import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { StatusModal } from "components/DesignSystem/StatusModal/StatusModal";
import { ModalProps } from "types/utils/modal";
import { pluralize } from "utils/pluralize";

export const RestoreConfirmation = ({
  isOpen,
  close,
  isLoading,
  confirm,
  itemCount = 1,
}: ModalProps & {
  isLoading: boolean;
  confirm: () => void;
  itemCount?: number;
}) => {
  const title = `Restore ${pluralize(itemCount, "file", "files", false)}?`;
  const description = pluralize(
    itemCount,
    "This file will be moved back to its original location in Documents.",
    `The selected ${itemCount} files will be moved back to its original location in Documents.`,
    false
  );

  return (
    <Modal.Root open={isOpen} onOpenChange={close}>
      <Modal.Content size="small">
        <StatusModal type="warning" title={title}>
          <div className="t-text-body-sm t-text-text-30">{description}</div>
        </StatusModal>
        <Modal.FooterButtonGroup>
          <Modal.RawClose asChild>
            <Button>Cancel</Button>
          </Modal.RawClose>
          <Button
            isLoading={isLoading}
            disabled={isLoading}
            customType="primary"
            onClick={confirm}
          >
            Restore file
          </Button>
        </Modal.FooterButtonGroup>
      </Modal.Content>
    </Modal.Root>
  );
};
